import { Component, OnInit, ViewEncapsulation, Inject,ViewChild } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import * as shape from 'd3-shape';

import { fuseAnimations } from '@fuse/animations';
import {DateMessageComponent} from 'app/main/pagina/tools/survey-status/survey-status.component';
import *  as $ from 'jquery';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';
import { CierreService } from 'app/main/wizard-cgo/services/cierre.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import Swal from 'sweetalert2';
const moment = require('moment');
const momentTz = require('moment-timezone');
import {MatDatepicker} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { MatInput } from '@angular/material/input';

//SERVICE
import { CloseService } from "app/main/pagina/productos/certificar/tipo_2/services/cierre.service";

import { AlertDialogComponent } from 'app/main/pagina/certificar/alertdialog/alertdialog.component';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';
///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_cierre } from 'app/idiomas/i18n/cierre/cierre.lang';
import { lang_shedule } from 'app/idiomas/i18n/shedule/shedule.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { DATOS_API } from 'app/auth/auth.datos';
import { SheduleService } from 'app/main/pagina/productos/certificar/tipo_2/services/shedule.service';
import { Cierren35Service } from 'app/main/wizard-n35encuestador/services/cierren35.service';
import { Envion35Service } from 'app/main/wizard-n35encuestador/services/envion35.service';
import * as backClose from 'app/main/pagina/productos/nom35/v3/cierre/close35.interface';
import { ProgramacionN35Service} from 'app/main/wizard-n35encuestador/services/programacionn35.service';
interface adverModal {
  tipo: number;
  mensaje: string;
  diccionario: string;
  confirma: boolean;


};
import { zonasUTC } from 'app/main/pagina/zonasUtc';
@Component({
    selector     : 'cierre-dashboard',
    templateUrl  : './cierre.component.html',
    styleUrls    : ['./cierre.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class ProjectDashboardComponent implements OnInit
{
   rutaPagina: string;
  claveConteos:string;
    url: string;
    projects: any[];
    fechasAvisos: any[];
    selectedProject: any;
    flagCierre: boolean = false;
    showButtonInstitute: boolean = true;
    dialogRef: any;

    // Datos certificar vigente
   productoCertificar: backInter.prodNorma35;
    clavesConteos: backInter.getClaveConteos;
    //boolean paso completo
    pasoCompleto = false;
    textoTurquia:boolean=false;

    widgets = {
        'tiempo'      : {
            'ranges'      : {
                'DT' : 'Today'
            },
            'currentRange': 'DT',
            'data'        : {
                'label': 'Dias restantes',
                'count': {
                    'DT' : 15
                },
                'extra': {
                    'label': 'Dias transcurridos',
                    'count': {
                        'DT' : 6
                    }
                }
            },
            'detail'      : '<h2>Más información</h2>Dia de lanzamiento de la encuesta:<br><b>01/09/2019</b><br><br>Día de cierre de la encuesta:<br><b>22/09/2019</b>'
        },
        'avance'      : {
            'ranges'      : {
                'DT' : 'Today'
            },
            'currentRange': 'DT',
            'data'        : {
                'label': 'Encuestas completas',
                'count': {
                    'DT' : '14%'
                },
                'extra': {
                    'label': 'Porcentaje restante',
                    'count': {
                        'DT' : '86%'
                    }
                }
            },
            'detail'      : '<h2>Más información</h2>Número de colaboradores encuestados: <b>343</b><br><br>Número de colaboradores con encuesta completa: <b>48</b><br><br>Número de colaboradores pendientes: <b>295</b>'
        }
    };

    dateNow = Date.now();

    getCodeURL: string;

    diasRestantes:any;
    fechaCierre:any;
    fechasRecordatorios: any[] = [];
    instituto:number;
    idiomaActual:string;
    recordatoriosFullInfo: any;
    recosHabilitados: boolean;

    contenido=[
      {
        titulo: 'Ver avance',
        Intruccion:'¿Qué desea realizar?',
        acciones:[
          {
          text:'Ingrese al siguiente enlace para visualizar el progreso actual de la encuesta:',
          accion:'Portal de conteos',
          icon:'vpn_key',
          visible: true,
        },
        {
        text:'Genere el enlace para visualizar el progreso actual de la encuesta:',
        accion:'Generar llave de acceso',
        icon:'vpn_key',
        visible: true,
        },
        {
        text:'Copie el enlace para visualizar el progreso actual de la encuesta:',
        accion:'Copiar llave de acceso',
        icon:'vpn_key',
        visible: false,
        },
      ]
      },
      {
        titulo: 'Recordatorios',
        Intruccion:'¿Qué desea realizar?',
        acciones:[
          {
          text:'',
          accion:'Enviar recordatorios',
          icon:'vpn_key',
          visible: true,
        },
        {
        text:'',
        accion:'Ver recordatorios registrados',
        icon:'vpn_key',
        visible: true,
        },
      ]
      },
      {
        titulo: 'Acceso a la encuesta',
        Intruccion:'¿Qué desea realizar?',
        acciones:[
          {
          text:'Portal GetMyCode.culturalgo.com',
          accion:'get my code',
          icon:'vpn_key',
          visible: true,
        },
        {
        text:'Portal de SMS virtual',
        accion:'Generar enlace de Provedor',
        icon:'vpn_key',
        visible: true,
        },
      ]
      },

    ]
    porcentaje:any;
    porcentaje2:any;
    tmp:any;
    tmp2:any;
    avanceEncuesta:backClose.objetoMenos50;
    typeSurvey1:boolean=false; // +mas
    typeSurvey2:boolean=false; // -50
    cargando:boolean=true;
    Finalizada1:boolean=false;
    Finalizada2:boolean;
    avaneLabel:string;
    Cargandocorreo:boolean=false;
    labelDate:any;
    arrayRemainders:any;
    arrayRemaindersExt:any;
    fechaLanzamiento:any;
    datosFechaProducto:any;
    fechaRecordatorioAnterior:any;
    urlAssetsEmail= DATOS_API.urlAssets;
    constructor(
      public dialog: MatDialog,
      private cierreService: CierreService,
      private service : CloseService,
      private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      private translateSrv: TranslateService,
      private wizardService: WizardService,
      private sheduleService: SheduleService,
      private _snackBar: MatSnackBar,
      private encuestaService: EncuestaService,
      private serviceNorma35 : Cierren35Service,
      private envioService: Envion35Service,
      private programacionServiceN35: ProgramacionN35Service,
    ){
        lang_certificar.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });
        lang_cierre.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });
        lang_shedule.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });

        setInterval(() => {
            this.dateNow = Date.now();
        }, 1000);

        console.log(localStorage.getItem('instituto'));

        if(localStorage.getItem('instituto') == '1'){
          this.showButtonInstitute = false;
        }else{
          this.showButtonInstitute = true;
        }

        if(localStorage.getItem('instituto') == 'TK'){
          this.textoTurquia = true;
        }else{
          this.textoTurquia = false;
        }
        this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
     ngOnInit() {
       this.obtieneCertificarActual();
       this.getInstituto();
       this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == parseInt(localStorage.getItem('instituto_id')));
      this.calculoOffsetPipe();
     }

     surveyType(type:any){
       console.log("Type  survey"+type);
       // 1 es menos de 50 y 2 más de 50
       if(type==1){
         localStorage.setItem('surveytype',"1");
       }else{
         localStorage.setItem('surveytype',"0");

       }

     }

     getInstituto(){
       switch(this.wizardService.getInstituto()){
         case '1': case 'MX': this.instituto = 1; break;
         case '2': case 'CAyC': this.instituto = 2; break;
         case '3': case 'HK': this.instituto = 3; break;
         case '4': case 'SGP': this.instituto = 4; break;
         case '5': case 'TK': this.instituto = 5; break;
         case '6': case 'FL': this.instituto = 6; break;
         case '8': case 'IZZI': this.instituto = 8; break;
         case '11': case 'BR': this.instituto = 11; break;
         case '14': case 'GCTI': this.instituto = 14;break;
         case '15': case 'ES': this.instituto = 15; break;
         case '18': case 'AMCO': this.instituto = 18; break;
       }
     }
     tokenSurvey:any;

     obtieneCertificarActual(){
       /// obtiene el producto certificar vigente
       this.cierreService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
         let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
         var BreakException = {};
         try {
             prodsCertificar.forEach( (producto) => {
               let fecha = producto.fechaNorma35;
               let idProducto = producto.idNorma35;
               if(fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')){
                 this.productoCertificar = producto;
                 // this.tokenSurvey=this.productoCertificar.tokenConfig;

                 this.cierre(this.productoCertificar.idNorma35);
                 throw BreakException;
               }
             });
         } catch (e) {
             if (e !== BreakException) throw e;
         };
         //obtiene el status del paso adicionales del certificar vigente
         this.serviceNorma35.getStatu(this.productoCertificar.idNorma35,true).subscribe( (data: backInter.getStatusIndiv) => {
           if(data.estatus === 3)
             this.pasoCompleto = true;
         });

       this.getFechaLanzamiento35();
         // this.getStatusModal();
         // this.getClaveConteo();
         // this.getUrlCode();
         // this.getAvisos();
         //obtiene las preguntas adicionales guardadas
       }, error  => {
         console.log("error al recuperar certificar vigente");
       });
     }

     getStatusModal(){
       let datos={
         productoId: this.productoCertificar.idNorma35,
         close: 1
       };
       console.log(datos);
       this.wizardService.getStatusModal(datos).subscribe( (data: backInter.getStatusModal) => {
         if(data.estatus==1){
               this.modalInformativo('CIERRE');
         }
       });
     }

     updateStatusModal(){
       let datos={
         productoId: this.productoCertificar.idNorma35,
         close: 2
       };
       // console.log(datos);
       this.wizardService.updateStatusModal(datos).subscribe( (data: any) => {
         // console.log(data);
       });
     }




     completarPaso(){
       if(this.pasoCompleto){
         //this.aletaRestric('CIERRE.COMPLETADO',null,'warning');
         let textomessage = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.COMPLETADO';
         this.translateSrv.get(textomessage).subscribe((res: string) => { textomessage = res; });
         this._snackBar.open(textomessage, "Ok", {
          duration: 2000,
          horizontalPosition: "center",
          verticalPosition: "top",
          panelClass: ['background-red']
         });
       }
       else{
         if(this.flagCierre){
           this.aletaRestric('CIERRE.COMPLETAR',true);
         }
         else{
           this.aletaRestric('CIERRE.NADA',null,'warning');
         }
         //COLOCAR CONDICIONES Y VALIDACIONES PARA COMPLETAR EL PASO
       }

     }

     enviaOrdenWizard(){
       this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
     }

     aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

       let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
       let rspSi = 'MODALES.ACCIONES.aceptar';
       let rspNo = 'MODALES.ACCIONES.cancelar';
       this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
       this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
       this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

       if(confirmar){
         Swal.fire({
           title: texto,
           icon: 'warning',
           showCancelButton: true,
reverseButtons: true,


           confirmButtonText: rspSi,
           cancelButtonText: rspNo
         }).then((result) => {
           if (result.value) {
             this.cierreService.guardaStatusCierre(this.productoCertificar.idNorma35).subscribe( (data: backInter.RespuestaGen) => {
               if(data.message == '217'){
                 this.aletaRestric('CIERRE.'+data.message,null,'success');
                 this.pasoCompleto = true;
                 this.enviaOrdenWizard();
               };
             });
           }
         });
       }
       else{
         let tipoMsg: any = tipo;
         Swal.fire({
           title: texto,
           icon: tipoMsg,
           confirmButtonText: rspSi,
           confirmButtonColor: '#e40601'
         });
       }

     }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle the sidebar
     *
     * @param name
     */
    toggleSidebar(name): void
    {

    }






  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,

      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }





  copyMessage(val: string, getUrl?:boolean){
    let texto = 'CIERRE.CIERRE.COPYLINK';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    // let url = DATOS_API.url.split(":");
    // this.rutaPagina = url[1] + "/surveyadministrator/counting/" + val;
    if(getUrl){
      this.rutaPagina = val;
    }
    else{
      if (this.instituto==14) {
        this.rutaPagina = DATOS_API.urlConteosGcti + val;
      }else{
        this.rutaPagina = DATOS_API.urlConteos + val;

      }
    }
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    // selBox.value=val;
    selBox.value=this.rutaPagina;
    console.log(this.rutaPagina);
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    Swal.fire({
      icon: 'success',
      title: texto,

      confirmButtonText: this.translateSrv.instant('CIERRE.ALERT.OK'),
    });

  }
  auxCorreo_array:any;
  banderaArreglo=0;


  dialogDate_message(fecha){
    localStorage.setItem('fechamessage',''+fecha);
    localStorage.setItem('offsetPipe_message',''+this.offsetPipe);
    const dialogRef = this.dialog.open(DateMessageComponent, {
      width: '40%',
    });
  }

  zonasUTC = zonasUTC;
  indiceZona: number;
  diferenciaUtc: number;
  offsetPipe: string;
  calculoOffsetPipe(){
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
  }






  getFechasRecordatoriosComponent(){

    const dialogRef = this.dialog.open(FechasRecordatoriosComponent, {
      width: '50%',
      disableClose: true,
      data: {
        tipo: 'Recordatorios',
        fechasRecordatorios: this.fechasRecordatorios,
        recordatoriosFullInfo: this.recordatoriosFullInfo,
        instituto: this.instituto,
        fechaLanzamiento:this.fechaLanzamiento,
        datosCompletos:this.datosFechaProducto,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      this.getFechaLanzamiento35();
    });
  }

  getAvisos(){
    this.encuestaService.getAviso().subscribe((respuesta:any) => {
      console.log("getAviso:",respuesta);
        if(respuesta.success){
      let arregloAviso:any[]=[];
      if(respuesta.aviso1){
        let aviso1={
        aviso:respuesta.aviso1,
        num:1}
        arregloAviso.push(aviso1)
      }
      if(respuesta.aviso2){
        let aviso2={
        aviso:respuesta.aviso2,
        num:2}
        arregloAviso.push(aviso2)
      }
      this.fechasAvisos=arregloAviso
    }
    });
  }

  getFechasAvisosComponent(){

    const dialogRef = this.dialog.open(FechasRecordatoriosComponent, {
      width: '50%',

      data: {
        tipo: 'Avisos',
        avisosRegistrados: this.fechasAvisos,
        instituto: this.instituto,
        fechaLanzamiento:this.fechaLanzamiento,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
      this.getAvisos();
    });
  }





  cierre(productoId){
    let dataEnc={
      productoId: this.productoCertificar.idNorma35
    };

    this.envioService.obtenerPilito(dataEnc).subscribe((response:backInter.getPilotoN35) => {
      console.log('response',response);

      if(response.success){
        if(response.urlMas50.length > 1 && response.urlMenos50.length>1){
          this.typeSurvey1=true;
          this.typeSurvey2=true;
          this.cargando=false;
          this.flagCierre=false;
          this.serviceNorma35.closesurvey(productoId,0).subscribe((data:backInter.surveyprogress) => {
            console.log('encuesta menos de 50',data);

            this.tmp=data.avance;
            this.porcentaje=this.tmp.porcentaje;
            this.serviceNorma35.closesurvey(productoId,1).subscribe((data2:backInter.surveyprogress) => {
              console.log('encuesta mas de 50',data);

              this.tmp2=data2.avance;
              this.porcentaje2=this.tmp2.porcentaje;
              console.log("porcentaje");
              console.log(this.porcentaje2);
              if(this.porcentaje2=='100'){

              }
              this.avaneLabel="Avance +50: ";
              if(this.porcentaje== '100' && this.porcentaje2=='100'){

              }
            });
          });

        }else{
          if(response.urlMas50.length > 1){
            console.log("urlMas50");
            this.serviceNorma35.closesurvey(productoId,0).subscribe((data:backInter.surveyprogress) => {
              this.flagCierre=false;
              this.tmp=data.avance;
              this.porcentaje=this.tmp.porcentaje;
              this.cargando=false;
              this.typeSurvey2=true;
              this.avaneLabel="Avance +50: ";
              if(this.porcentaje== 100 && this.porcentaje2==100){
                this.Finalizada2=true;
              }
            });
          }
          if(response.urlMenos50.length>1){
            console.log("urlmeos50");
            this.serviceNorma35.closesurvey(productoId,1).subscribe((data:backInter.surveyprogress) => {
              this.flagCierre=false;
              this.tmp=data.avance;
              this.porcentaje=this.tmp.porcentaje;
              this.cargando=false;
              this.typeSurvey1=true;
              this.avaneLabel="Avance -50: ";
              console.log("Porcentaje");
              console.log(this.porcentaje);
              if(this.porcentaje== 100){
                this.Finalizada1=true;
              }
          });
          }

        }
      }
    }, error => {
      console.log(error);
    });


  }

  sendReminderMenos50(tipoEncuesta:any){
console.log("menos de 50",tipoEncuesta);

    this.modalEspera(5);
      this.Cargandocorreo=true;
      var now = new Date();
      var date2 = new Date(now),
       mnth = ("0" + (date2.getMonth() + 1)).slice(-2),
        day = ("0" + date2.getDate()).slice(-2);
      var timestamp1 = new Date(this.labelDate).getTime();
      var timestamp2 = new Date(date2).getTime();
      if(timestamp2>timestamp1){
        let dataRecor={
          productoId: this.productoCertificar.idNorma35,
        };
        this.envioService.GetRecordatoriosManuales(dataRecor).subscribe((response:any) => {
          let arrayRecordMeno50=[];
          if (response.recordatoriosManuales.length>0) {
            response.recordatoriosManuales.forEach(record => {
              if (record.norma35TipoEncuesta==1) {
                arrayRecordMeno50.push(record);
              }

            });
          }
          this.auxCorreo_array=arrayRecordMeno50;
            // this.auxCorreo_array=response.recordatoriosManuales;
              var pos= this.auxCorreo_array.length;
              if(pos == 0){
                this.enviarCorreos(tipoEncuesta);
              }else if(pos > 0) {
                let fechaUltimoRecordartorio=moment(this.auxCorreo_array[pos-1].fechaRecordatorio);
                let fechaHoy=moment();
                var timestampRecordatorio1 = new Date(this.auxCorreo_array[pos-1].fechaRecordatorio).getTime();
                var timestampRecordatorio2 = new Date(date2).getTime();
                console.log();

                var tiempoRecordatorios = timestampRecordatorio2-timestampRecordatorio1;
                if(moment(fechaHoy).isAfter(moment(fechaUltimoRecordartorio))){
                  this.enviarCorreos(tipoEncuesta);
                }else{
                  this.Cargandocorreo=false;
                  Swal.close();
                  let texto = 'CIERRE.LABEL6';
                  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                  Swal.fire({
                    title: texto,
                    icon: "error",
                    confirmButtonColor: '#e40601'
                  });
                }
              }

        }, error => {
              console.log(error);
        });
      }else{
        let texto = 'CIERRE.LABEL7';
        this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
        Swal.fire({
          title: texto,
          icon: "error",
          confirmButtonColor: '#e40601'
        });
        setTimeout(() => {
          this.Cargandocorreo=false;
        }, 1000);
      }
}

  sendReminderMas50(tipoEncuesta:any){
console.log("mas de 50",tipoEncuesta);
    this.modalEspera(5);
      this.Cargandocorreo=true;
      var now = new Date();
      var date2 = new Date(now);
      var mnth = ("0" + (date2.getMonth() + 1)).slice(-2);
      var day = ("0" + date2.getDate()).slice(-2);
      var timestamp1 = new Date(this.labelDate).getTime();
      var timestamp2 = new Date(date2).getTime();
      if(timestamp2>timestamp1){
        let dataRecor={
          productoId: this.productoCertificar.idNorma35,
        };
        this.envioService.GetRecordatoriosManuales(dataRecor).subscribe((response:any) => {
          let arrayRecordMas50=[];
          if (response.recordatoriosManuales.length>0) {
            response.recordatoriosManuales.forEach(record => {
              if (record.norma35TipoEncuesta==2) {
                arrayRecordMas50.push(record);
              }

            });
          }
          this.auxCorreo_array=arrayRecordMas50;
            // this.auxCorreo_array=response.recordatoriosManuales;
              var pos= this.auxCorreo_array.length;
              if(pos == 0){
                this.enviarCorreos(tipoEncuesta);
              }else if(pos > 0) {
                let fechaUltimoRecordartorio=moment(this.auxCorreo_array[pos-1].fechaRecordatorio);
                let fechaHoy=moment();
                var timestampRecordatorio1 = new Date(this.auxCorreo_array[pos-1].fechaRecordatorio).getTime();
                var timestampRecordatorio2 = new Date(date2).getTime();
                var tiempoRecordatorios = timestampRecordatorio2-timestampRecordatorio1;
                if(moment(fechaHoy).isAfter(moment(fechaUltimoRecordartorio))){
                  this.enviarCorreos(tipoEncuesta);
                }else{
                  this.Cargandocorreo=false;
                  Swal.close();
                  let texto = 'CIERRE.LABEL6';
                  this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
                  Swal.fire({
                    title: texto,
                    icon: "error",
                    confirmButtonColor: '#e40601'
                  });
                }
              }

        }, error => {
              console.log(error);
        });
      }else{
        let texto = 'CIERRE.LABEL7';
        this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
        Swal.fire({
          title: texto,
          icon: "error",
          confirmButtonColor: '#e40601'
        });
        setTimeout(() => {
          this.Cargandocorreo=false;
        }, 1000);
      }
}

  enviarCorreos(tipoEncuesta){

    let dataEnc={
      productoId: this.productoCertificar.idNorma35,
      tipoEncuesta: tipoEncuesta
    };
    console.log('dataEnc',dataEnc);

    this.envioService.RecordatoriosManualesV3(dataEnc).subscribe((response:any) => {
      this.Cargandocorreo=false;
      console.log("Respuesta recordatorios");
      console.log(response);
      let texto = 'CIERRE.LABEL5';
      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
      Swal.close();
      Swal.fire({
        title: texto,
        icon: "success",
        confirmButtonColor: '#e40601'
      });

    }, error => {
      console.log(error);
    });
  }

  getFechaLanzamiento35(){

      this.programacionServiceN35.getDateLanNormv2(this.productoCertificar.idNorma35).subscribe((response:any) => {
          if(response.success ){
            console.log(response);

            this.fechaLanzamiento = response.programacion.fechaLanzamiento;
            this.labelDate=response.programacion.fechaLanzamiento;
            this.datosFechaProducto = response.programacion;
            console.log("Fecha message");
            console.log(this.fechaLanzamiento);
            if(moment().isAfter(moment(this.fechaLanzamiento))){
              this.recosHabilitados = true;
            }
            let aux: string = '';

            this.recordatoriosFullInfo =  response.programacion.recordatorios;
           response.programacion.recordatorios.forEach(recordatorio => {
              this.fechasRecordatorios.push( recordatorio.fechaRecordatorio );
            });
            console.log("fechasREcos:",this.fechasRecordatorios);

          }
      }, error => {
        console.log(error);
      });
  }

  modalEspera(tipo){
    let text:string;
    switch (tipo) {
      case 5: //elimina fecha aviso
        text=this.translateSrv.instant('CIERRE.MOD_TEX_SEND_RECO');
        break;

      default:
        break;
    }

    Swal.fire({
      imageUrl:this.urlAssetsEmail+'platform/img/tenor.gif',
      title: text,
      allowOutsideClick: false,
      imageWidth: 100,
      imageHeight: 90,
      showConfirmButton:false
    });
  }
}



@Component({
  selector: 'FechasRecordatoriosComponent',
  templateUrl: './RecordatoriosCierre.dialog.component.html',
  styleUrls: ['./RecordatoriosCierre.component.scss'],
  animations : fuseAnimations
})


export class FechasRecordatoriosComponent implements OnInit {
    @ViewChild('recordatorioFechas', { read: undefined }) calReco2: MatDatepicker<Date>;
    @ViewChild('avisoFechas', { read: undefined }) calAviso2: MatDatepicker<Date>;
  idiomaActual:string;
  offsetPipe: string;
  //zonas horarias

  indiceZona: number;
  horaInstituto: any;
  diferenciaUtc: number;
  filtroHoraHoy: any;
  horaInstitutoTag: any;

  zonasUTC = zonasUTC;


  recordatorioBorrado: boolean;
  fechaLanzamiento=true;
  idRecordatorio:any;
  recordatoriosPermitidos = 1000;
  filtroRecordatorios: any;
  filtroAviso: any;
  filtroAviso1: any;
  filtroAviso2: any;
  fechaRecoTemp: any;
  fechaAvisoTemp: any;
  avisoFechaAvisoActual: any;
  indiceFechaAvisoActual: any;
  recordatorioActualizado: boolean;
  ///Filtro para el primerAviso:
  esHoy: boolean;
  fechaRecordatorioAnterior:any;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<FechasRecordatoriosComponent>,
    private translateSrv: TranslateService,
    private sheduleService: SheduleService,
    private _snackBar: MatSnackBar,
    private programacionServiceN35: ProgramacionN35Service,
    // private surveyServ: SurveyStatusService,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
  }

  ngOnInit() {
    console.log("datos: ",this.data);
    console.log("instituto #:",localStorage.getItem('instituto'));
      this.filtroRecordatorios = (d: Date | null): boolean => {
        var moment = require('moment');
        const diaInicial = moment(this.data.fechaLanzamiento);
        const diaFinal = moment(this.data.fechaLanzamiento).add(21,'days');
        const diaActual = moment(d || new Date());
        return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal)
      };

      this.filtroAviso1 = (d: Date | null): boolean => {
        let fechaAviso1:any;
        let diaInicial: any;
        if(this.esHoy){
          diaInicial = moment();
        }
        else{
          diaInicial = moment().add(1,'days');
        }

        const diaFinal = moment(this.data.fechaLanzamiento).subtract(1,'days');
        const diaActual = moment(d || new Date());
        if (moment().format('YYYY') == moment(d||new Date()).format('YYYY')) {
          console.log("entro lo del mismo año");

          fechaAviso1= diaActual.clone().format('MM/DD/YYYY') >= diaInicial.clone().format('MM/DD/YYYY') && diaActual.isBefore(diaFinal)
        }else{
          console.log("entro lo del otrooooo añooooo");
          fechaAviso1= moment(d || new Date()).format('MM/DD/YYYY') < diaFinal.clone().format('MM/DD/YYYY')

        }

        return fechaAviso1;
      };

      this.filtroAviso2 = (d: Date | null): boolean => {
        // this.fechaInicialGenerica = new Date(moment(this.fechas[1].fecha).year(), moment(this.fechas[1].fecha).month(), 1);
        const diaInicial = moment(this.data.avisosRegistrados[0].aviso);
        const diaFinal = moment(this.data.fechaLanzamiento).subtract(1,'days');
        const diaActual = moment(d || new Date());
        return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal)
      };
    this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == this.data.instituto);
    this.horaInstituto = momentTz.tz(this.zonasUTC[this.indiceZona].zona).utc(true);
    this.horaInstitutoTag = momentTz.tz(this.zonasUTC[this.indiceZona].zona);
    this.calculoOffsetPipe();
    this.calculoHoraMinima();
  }



  calculoOffsetPipe(){
    this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    console.log("diferenciaUtc:",this.diferenciaUtc);
    let horas = this.diferenciaUtc / 60;
    if(horas < 0){
      horas = horas * -1;
      if(horas < 10){
        this.offsetPipe = "-0" + horas + "00";
      }
      else{
        this.offsetPipe = "-" + horas + "00";
      }
    }
    else{
      if(horas < 10){
        this.offsetPipe = "+0" + horas + "00";
      }
      else{
        this.offsetPipe = "+" + horas + "00";
      }
    }
    console.log("offsetPipe:",this.offsetPipe);
  }

  borraRecordatorio(fecha:string, indice:number){
    Swal.fire({
      title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.BORRA_RECO_1') +': \n\n' + moment(fecha).format('DD-MM-YYYY'),
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
      cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
    }).then((result) => {
      if (result.value) {
        //LLAMAR AL SERVICIO QUE LA BORRA EN BACK
        const datosRecoFull = this.data.datosCompletos.recordatorios.find(item => item.fechaRecordatorio == fecha);
        if(datosRecoFull != undefined){
            this.data.datosCompletos.recordatorios.splice(indice,1);
          this.recordatorioBorrado = true;
              let data={
                productoId : localStorage.getItem('productoID'),
                fechaLanzamiento: this.data.datosCompletos.fechaLanzamiento,
                fechaCierre:this.data.datosCompletos.fechaCierre,
                recordatorios:this.data.datosCompletos.recordatorios,
                recordatoriosN35:this.data.datosCompletos.recordatoriosN35,
              };

              console.log('Datis a guardar',data);
          this.modalEspera(3);
          this.programacionServiceN35.registerDateLanNormv2(data).subscribe((respuesta:any) => {
            console.log("deleteRecordatorio",respuesta);
            this.openSnackBar(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.BORRA_RECO_2'),this.translateSrv.instant('ALERTS.OK'));
            Swal.close();
          }, error => {
            console.log(error);
          });
        }
      }
    });
  }

  borraAviso(fecha:string, indice:number){
    Swal.fire({
      title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.BORRA_AVI_1') +': \n\n' + moment(fecha).format('DD-MM-YYYY'),
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
      cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
    }).then((result) => {
      if (result.value) {
        //LLAMAR AL SERVICIO QUE LA BORRA EN BACK
        // const datosRecoFull = this.data.avisosRegistrados.find(item => item.aviso == fecha);
        // if(datosRecoFull != undefined){
        // this.recordatorioBorrado = true;
          let data: any = {
            productoId: localStorage.getItem('productoID'),
            fechaAviso: fecha,
          };
          this.modalEspera(4);
          this.sheduleService.deleteAvisos(data).subscribe((respuesta:any) => {
            console.log("deleteAvisos",respuesta);
            this.data.avisosRegistrados.splice(indice,1);
            this.openSnackBar(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.BORRA_AVI_2'),this.translateSrv.instant('ALERTS.OK'));
            Swal.close();
          }, error => {
            console.log(error);
          });
        // }
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  salir() {
    this.dialogRef.close();
  }

  fechaRecordatorio(origen:number, event){
    console.log("evento:",event);
    let fechaElegida = event.value;
    let moment = require('moment');
    if(origen == 2){
      if(this.fechaLanzamiento){
        let arr=[];
        this.data.recordatoriosFullInfo.forEach(element => {
          arr.push(moment(element.fechaRecordatorio).format('MM/DD/YYYY'))
        });
console.log('arr',arr);
        if(!arr.includes( moment(fechaElegida).format('MM/DD/YYYY') )){
          console.log("registra el recordatorio");
          //this.registerRecordatorio(date,date);
          this.guardaRecordatorio(fechaElegida);
        }
        else{
          this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOEXIS'), 3);
        }
      }
      else{
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
      }
    }
  }

  fechaAviso(origen:number, event, fechaAnterior,indice){

    let moment = require('moment');
    let fechaElegida = event.value;
    let fechaMoment = moment(fechaElegida).format('YYYY-MM-DD');
    console.log("fechaNueva:",event);
    console.log("fechaAnterior:",fechaAnterior);
    console.log("fechamoment:",fechaMoment," fechaActual:",moment().format('YYYY-MM-DD'));
    if(fechaMoment == moment().format('YYYY-MM-DD')){
      this.setFiltroHoraHoy(true);
    }
    else{
      if(fechaMoment == moment().add(1,'days').format('YYYY-MM-DD')){
        this.setFiltroHoraHoy(false,true);
      }
      else{
        this.setFiltroHoraHoy(false);
      }
    }

    setTimeout(() => {

      if(origen == 2){
        if(this.fechaLanzamiento){
          if(!this.data.avisosRegistrados.includes( moment(fechaElegida).format('MM/DD/YYYY') )){
            console.log("registra el recordatorio");
            this.actualizarAviso(fechaElegida,fechaAnterior);
          }
          else{
            this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOEXIS'), 3);
          }
        }
        else{
          this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
        }
      }
    }, 200);
  }

  guardaRecordatorio(fecha){
    let moment = require('moment');
    this.fechaRecoTemp = moment(fecha).format('YYYY-MM-DD');
    console.log('this.fechaRecoTemp',this.fechaRecoTemp);

    $("#timepickerRecosUpdat").click();

  }

  horaSeleccionadaRecoUpdate(event){
    let moment = require('moment');
    let hora24 = moment(event, ["h:mm A"]).format("HH:mm");
    this.fechaRecoTemp = this.fechaRecoTemp + " " + hora24;

    let fechaActual = momentTz.tz(this.zonasUTC[this.indiceZona].zona);
    let diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    let diferenciaMinutos = momentTz.tz(this.fechaRecoTemp,this.zonasUTC[this.indiceZona].zona).diff(fechaActual, 'seconds');
    let fechaActualTransformada = moment(fechaActual).add(diferenciaMinutos, 'seconds');
    diferenciaUtc = diferenciaUtc * -1; //invierte los minutos de diferencia con respecto a utc 0
    let fechaTransformadaMasDifUtc = moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'seconds'); //se le añade 1 minutos porque siempre se desfasa alv -_-

    console.log("fechaActual:",fechaActual.format());
    console.log("diferenciaUtc:",diferenciaUtc);
    console.log("diferenciaMinutos:",diferenciaMinutos);
    console.log("fechaActualTransformada:",fechaActualTransformada.format());
    console.log("fechaTransformadaMasDifUtc:",fechaTransformadaMasDifUtc.utc(true).toISOString());
    this.data.recordatoriosFullInfo.forEach((fechaActual,i) => {
      if (fechaActual.fechaRecordatorio==this.fechaRecordatorioAnterior) {
        this.data.recordatoriosFullInfo.splice(i,1);
      }
    });

    this.data.recordatoriosFullInfo.push({fechaRecordatorio:fechaTransformadaMasDifUtc.utc(true).toISOString()})

    let data={
        productoId : localStorage.getItem('productoID'),
        fechaLanzamiento:   this.data.datosCompletos.fechaLanzamiento,
        fechaCierre:  this.data.datosCompletos.fechaCierre,
        recordatorios:this.data.recordatoriosFullInfo,
        recordatoriosN35:this.data.datosCompletos.recordatoriosN35,
      };
    console.log("datosRecoNuevo:",data);
    this.modalEspera(2);
    this.programacionServiceN35.registerDateLanNormv2(data).subscribe((respuesta:any) => {
      console.log("guardaReco",respuesta);
      if(respuesta.success){
        this.openSnackBar(this.translateSrv.instant('SHEDULE.REMIDERUPDAOK'),this.translateSrv.instant('ALERTS.OK'));
        Swal.close();
        this.recordatorioActualizado=true;
      }
    }, error => {
    });

  }

  actualizarAviso(fecha,fechaAnterior){
    let moment = require('moment');
    this.fechaAvisoTemp = moment(fecha).format('YYYY-MM-DD');
    console.log('this.fechaRecoTemp',this.fechaAvisoTemp);

    $("#timepickerAvisoUpdat").click();

  }


  horaSeleccionadaAviUpdate (event){
    let moment = require('moment');
    let hora24 = moment(event, ["h:mm A"]).format("HH:mm");
    this.fechaAvisoTemp = this.fechaAvisoTemp + " " + hora24;

    let fechaActual = momentTz.tz(this.zonasUTC[this.indiceZona].zona);
    let diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
    let diferenciaMinutos = momentTz.tz(this.fechaAvisoTemp,this.zonasUTC[this.indiceZona].zona).diff(fechaActual, 'seconds');
    let fechaActualTransformada = moment(fechaActual).add(diferenciaMinutos, 'seconds');
    diferenciaUtc = diferenciaUtc * -1; //invierte los minutos de diferencia con respecto a utc 0
    let fechaTransformadaMasDifUtc = moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'seconds'); //se le añade 1 minutos porque siempre se desfasa alv -_-

    console.log("fechaActual:",fechaActual.format());
    console.log("diferenciaUtc:",diferenciaUtc);
    console.log("diferenciaMinutos:",diferenciaMinutos);
    console.log("fechaActualTransformada:",fechaActualTransformada.format());
    console.log("fechaTransformadaMasDifUtc:",fechaTransformadaMasDifUtc.utc(true).toISOString());

    let data={
      productoId: localStorage.getItem('productoID'),
      fechaAviso: this.avisoFechaAvisoActual,
      updateAviso: fechaTransformadaMasDifUtc.utc(true).toISOString(),
      //encuestaId: localStorage.getItem('encuestaID')  //cuando se trata de focus area alv
    };
    console.log("datosRecoNuevo:",data);
      this.modalEspera(1);
    this.sheduleService.updateAvisoFecha(data).subscribe((respuesta:any) => {
      console.log("guardaReco",respuesta);
      if(respuesta.message == '200'){
        Swal.close();
        this.openSnackBar(this.translateSrv.instant('SHEDULE.AVIUPDAOK'),this.translateSrv.instant('ALERTS.OK'));
        // this.recordatorioActualizado=true;
        this.data.avisosRegistrados[this.indiceFechaAvisoActual].aviso=fechaTransformadaMasDifUtc.utc(true).toISOString();
      }
    }, error => {
    });

  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  updRecordatorio(fecha, i){
    console.log('fecha',fecha);

  this.idRecordatorio=fecha._id;
  this.fechaRecordatorioAnterior=fecha.fechaRecordatorio;

    if(this.fechaLanzamiento){
      console.log('entro aquie 1');
      if(this.data.fechasRecordatorios.length < this.recordatoriosPermitidos){
        console.log('entro aquie 2');

        this.calReco2.open();
      }
      else{
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOMAX'), 2);
      }
    }
    else{
      this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
    }
  }

  updFechaAviso(fecha, i){
    console.log('fecha',fecha);
    if (i==0) {
      console.log('Seleccionando  fecha  indice::',i);
      this.filtroAviso=this.filtroAviso1;
    }else if (i==1) {
      this.filtroAviso=this.filtroAviso2;

    }
this.indiceFechaAvisoActual=i;
this.avisoFechaAvisoActual=fecha.aviso;

    if(this.fechaLanzamiento){
      console.log('entro aquie 1');
      // if(this.data.fechasRecordatorios.length < this.recordatoriosPermitidos){
        console.log('entro aquie 2');

        this.calAviso2.open();
      // }
      // else{
      //   this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOMAX'), 2);
      // }
    }
    else{
      this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
    }
  }





  modalEspera(tipo){
    let text:string;
    switch (tipo) {
      case 1: //actualiza fecha aviso
        text=this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.UPDA_AVISO');
        break;
      case 2: //actualiza fecha Recordatorio
        text=this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.UPDA_RECOR');
        break;
      case 3: //elimina fecha Recordatorio
        text=this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.DELE_RECOR');
        break;
      case 4: //elimina fecha aviso
        text=this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.DELE_AVISO');
        break;
      case 5: //elimina fecha aviso
        text=this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.DELE_AVISO');
        // text="Enviando email";
        break;

      default:
        break;
    }

    Swal.fire({
      title: text,
      allowOutsideClick: false,
      showConfirmButton: false,
      imageUrl: localStorage.getItem('urlGifBroker'),
      imageWidth: 100,
      imageHeight: 60,
      // didOpen: () => {
      //   Swal.showLoading()
      // }
    });
  }

  calculoHoraMinima(){
    let horaMinima = this.horaInstituto.clone().add(4,'hours').format('YYYY-MM-DD');
    let horaActual = moment().format('YYYY-MM-DD');
    // console.log("horaMinima:",horaMinima," horaActual:",horaActual);
    let esHoy = moment(horaActual).isSame(horaMinima);
    this.esHoy = esHoy;
    // console.log("es aun hoy?:",esHoy);
  }

  setFiltroHoraHoy(hoy:boolean,diaSiguiente?:boolean){
    if(hoy){
      console.log("aplicado filtro de hora para hoy");
      // let horaActualMasCuatro = moment().add(4,'hours');
      let horaActualMasCuatro = this.horaInstituto.clone().add(4,'hours');
      if(horaActualMasCuatro.hours() > 12){
        this.filtroHoraHoy = (horaActualMasCuatro.hours()-12) + ":" + horaActualMasCuatro.minutes() + " pm";
      }
      else{
        this.filtroHoraHoy = horaActualMasCuatro.hours() + ":" + horaActualMasCuatro.minutes() + " am";
      }
    }
    else{
      if(diaSiguiente){
        console.log("aplicado filtro de hora del dia siguiente a hoy");
        if(this.esHoy){
          this.filtroHoraHoy = "00:00 am";
        }
        else{
          let horaActualMasCuatro = this.horaInstituto.clone().add(4,'hours');
          if(horaActualMasCuatro.hours() > 12){
            this.filtroHoraHoy = (horaActualMasCuatro.hours()-12) + ":" + horaActualMasCuatro.minutes() + " pm";
          }
          else{
            this.filtroHoraHoy = horaActualMasCuatro.hours() + ":" + horaActualMasCuatro.minutes() + " am";
          }
        }
      }
      else{
        console.log("aplicado filtro de hora para otro dia");
        this.filtroHoraHoy = "00:00 am";
      }
    }

    console.log("filtroHoraHoy:",this.filtroHoraHoy);
  }


}
